import React from "react";

interface AdminPanelProps {
  imagePaths: string[];
  hitCounts: Record<string, number>;
  selectedGoalIndex: number | null;
  onSelectGoal: (index: number) => void;
  onReplaceGoalImage: (newPath: string) => void;
  onResetHits: () => void;
  onExitAdmin: () => void;
  allAvailableImages: readonly string[];
}

export default function AdminPanel({
  imagePaths,
  hitCounts,
  selectedGoalIndex,
  onSelectGoal,
  onReplaceGoalImage,
  onResetHits,
  onExitAdmin,
  allAvailableImages,
}: AdminPanelProps) {
  return (
    <div className="admin-screen">
      <button onClick={onExitAdmin}>Voltar para o modo de jogo</button>
      <h2>Administração: Alterar imagens de destino</h2>

      <div className="selected-goals">
        {imagePaths.map((path, i) => (
          <div
            key={i}
            className={`image goal-image ${
              selectedGoalIndex === i ? "selected" : ""
            }`}
            onClick={() => onSelectGoal(i)}
            style={{ cursor: "pointer" }}>
            <img src={path} alt={`Destino ${i}`} />
            <div>Acertos: {hitCounts[path] ?? 0}</div>
          </div>
        ))}
      </div>

      <h3>Escolha a imagem de substituição</h3>
      <div className="catalog">
        {allAvailableImages.map((path, i) => (
          <div
            key={i}
            style={{
              display: "inline-block",
              margin: 8,
              textAlign: "center",
            }}>
            <img
              className="catalog-image"
              src={path}
              alt={`Catálogo ${i}`}
              onClick={() =>
                selectedGoalIndex !== null && onReplaceGoalImage(path)
              }
              style={{
                cursor: selectedGoalIndex !== null ? "pointer" : "default",
                border: selectedGoalIndex !== null ? "1px solid #ccc" : "none",
                display: "block",
                maxWidth: 100,
                height: "auto",
                marginBottom: 4,
              }}
            />
            <div>Acertos: {hitCounts[path] ?? 0}</div>
          </div>
        ))}
      </div>

      <button onClick={onResetHits}>Redefinir contagem de acertos</button>
    </div>
  );
}
